var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.980957,
    width: 23.7913,
    height: 24.0381,
    rx: 11.8957,
    fill: "#FF4519"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93969 10.5246C6.94438 10.5193 6.9514 10.5139 6.95218 10.5077C7.04823 10.0831 7.46678 9.87117 7.94077 10.0785C8.42022 10.2881 8.8989 10.4985 9.37835 10.7089C10.0757 11.0146 10.7738 11.3171 11.4695 11.6258C11.7522 11.751 12.0263 11.7479 12.3097 11.6227C13.481 11.1052 14.6555 10.593 15.8283 10.0793C16.004 10.0025 16.186 9.96638 16.375 10.0201C16.8162 10.1461 16.9801 10.699 16.685 11.086C16.5311 11.2879 16.3679 11.4853 16.1961 11.6726C14.9585 13.0234 13.7192 14.3725 12.4761 15.7187C12.1223 16.1011 11.6468 16.0995 11.2938 15.7171C10.0226 14.338 8.756 12.955 7.48864 11.572C7.37542 11.4484 7.26375 11.3225 7.16849 11.1858C7.08025 11.0599 7.01466 10.9193 6.93969 10.785V10.5246Z",
    fill: "#FF4519"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.bc86393849c481ae961a180e91ba73c1.svg";
export { ForwardRef as ReactComponent };